import React, { Component } from 'react';
import { productListingTypeEnum, productSearchLengthEnum } from '../../utility/enums';
import { genarateProductSearchURL } from '../../utility/commonFunctions';

/*-- Imports for redux --*/
import { connect } from 'react-redux';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        webDataCollection: state.webDataCollection
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {};

/**
 * Date     :   2020-06-15
 * Author   :   Dinushka Rukshan
 * Remarks  :   Product auto complete search component
 */
class AutoCompleteText extends Component {
    constructor(props) {
        super(props)
        this.autoCompleteRef = React.createRef();
        this.onTextChanged = this.onTextChanged.bind(this);
        this.suggestionsSelected = this.suggestionsSelected.bind(this);
        this.suggestionsOnClick = this.suggestionsOnClick.bind(this);
        this.handleAutoCompleteClickOutside = this.handleAutoCompleteClickOutside.bind(this);

        this.state = {
            searchText: "",
            suggestions: []
        };
    };

    handleAutoCompleteClickOutside(event) {
        if (this.autoCompleteRef && !this.autoCompleteRef.current.contains(event.target)) {
            this.setState({
                searchText: "",
                suggestions: []
            })
        }
    };

    onTextChanged = (event) => {
        let suggestions = [];
        const searchValue = event.target.value.toUpperCase();
        if (searchValue == "") {
            this.setState({ suggestions, searchText: searchValue });
        }
        else if (!(!/^[A-Za-z0-9-.&,/ /']+$/.test(searchValue))) {
            if (searchValue.length > productSearchLengthEnum.productSearchLength) {
                //     const regex = new RegExp(`(?:${searchValue.toUpperCase()})`, 'i');
                //     suggestions = this.props.webDataCollection.suggestedItemsList.sort().filter(product => regex.test(product.itemName));

                suggestions = this.props.webDataCollection.suggestedItemsList.sort().filter(product => product.itemName.toUpperCase().includes(searchValue));
            }
            this.setState({ suggestions, searchText: searchValue.toUpperCase() });
        }
    };

    suggestionsSelected(product) {
        this.setState({
            searchText: product.itemName,
            suggestions: []
        }, () => {
            document.removeEventListener('click', this.handleAutoCompleteClickOutside);
            window.location.href = genarateProductSearchURL(product.itemName);
        })
    };

    suggestionsOnClick(e) {
        if (e.keyCode === 13) {
            window.location.href = genarateProductSearchURL(this.state.searchText);
        }
    }

    renderSuggestions() {
        const { suggestions } = this.state;
        if (suggestions.length === 0) {
            document.removeEventListener('click', this.handleAutoCompleteClickOutside);
            return null;
        } else {
            document.addEventListener('click', this.handleAutoCompleteClickOutside);
            return (
                <ul ref={this.autoCompleteRef}>
                    {suggestions.map((product, index) => <li key={index} onClick={() => this.suggestionsSelected(product)}>{product.itemName}</li>)}
                </ul>
            );
        }
    };

    render() {
        return (
            <div className="auto-complete-text">
                <input type="text" placeholder="Search for any product" value={this.state.searchText} onChange={this.onTextChanged} onKeyDown={(e) => this.suggestionsOnClick(e)} />
                {this.renderSuggestions()}
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AutoCompleteText);